import { useEffect } from 'react';
import { Button, Spinner } from '@radix-ui/themes';
import { clearCacheMap } from 'api';
import { Link } from 'react-router-dom';
import { fetchNotificationsDropdown } from 'store/notifications/notificationsSlice';
import { useAppDispatch, useAppSelector } from 'store/store';
import Notification from './Notification';

export const NotificationHeader: React.FC<{ counter: number }> = ({ counter }) => {
  const dispatch = useAppDispatch();
  const { data, loading } = useAppSelector((state) => state.notifications);

  useEffect(() => {
    clearCacheMap();
    dispatch(fetchNotificationsDropdown(1));
    return () => {
      clearCacheMap();
    };
  }, [dispatch]);

  return (
    <div className='overflow-x-hidden'>
      <div id='title' className='flex flex-col items-start gap-2 self-stretch'>
        <div className='text-neutral-neutral-12 self-stretch text-lg font-medium tracking-tight'>
          Notifiche ({counter})
        </div>
      </div>
      {loading ? (
        <Spinner />
      ) : (
        <div className='flex flex-col items-start justify-between gap-2 self-stretch rounded-md px-3 py-2'>
          {counter !== 0 &&
            data.map((notification) => <Notification notification={notification} key={notification.id} />)}
        </div>
      )}
      <div id='seeAll' className='flex w-full justify-end'>
        <Link to='/notifiche'>
          <Button size='2' color='lime'>
            Vedi tutte
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default NotificationHeader;
